// src/mobile_pages/materials/MaterialsLayout.jsx
import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";

const sections = [
  {
    title: "자재 게시판",
    items: [{ to: "list/all", label: "전체 문서 목록", end: true }],
  },

  {
    title: "수급계획 (PS)",
    items: [
      { to: "list/ps", label: "문서 목록" },
      {
        to: { pathname: "plan/new", search: "?form_type=PS" },
        label: "PS 작성",
      },
    ],
  },

  {
    title: "발주서 (PO)",
    items: [
      { to: "list/po", label: "문서 목록" },
      {
        to: { pathname: "order/new", search: "?form_type=PO" },
        label: "PO 작성",
      },
    ],
  },

  {
    title: "입고/출고",
    items: [
      { to: "list/gr", label: "입고(GR) 목록" },
      { to: "list/gi", label: "출고(GI) 목록" },
      {
        to: { pathname: "inout/new", search: "?form_type=GR" },
        label: "입고서 작성",
      },
      {
        to: { pathname: "inout/new", search: "?form_type=GI" },
        label: "출고서 작성",
      },
    ],
  },

  {
    title: "검측요청서",
    items: [
      { to: "list/qc", label: "검수요청(QC) 목록" },
      { to: "list/ck", label: "검수확인(CK) 목록" },
      {
        to: { pathname: "check/new", search: "?form_type=QC" },
        label: "검수 요청",
      },
      {
        to: { pathname: "check/new", search: "?form_type=CK" },
        label: "검수 확인",
      },
    ],
  },

  {
    title: "재고",
    items: [{ to: "stock", label: "재고 현황" }],
  },
];

export default function MaterialsLayout() {
  return <Outlet />;
}
